import LdsIcon from '../LdsIcon/index.jsx';
export default function LinkBase({
  itemText,
  newTab = false,
  href,
  tabIndex = '1',
  ariaLabel = null,
  iconName = '',
  iconPosition = 'after',
  externalCallback = () => {},
}) {
  return (
    <div className="link-wrapper">
      <a
        aria-label={ariaLabel || itemText}
        className="lds-link"
        href={href}
        onClick={externalCallback}
        rel={newTab ? 'noreferrer' : null}
        tabIndex={tabIndex}
        target={newTab ? '_blank' : null}
      >
        {iconName.length > 0 && iconPosition === 'before' && (
          <>
          <LdsIcon name={iconName} inline decorative />
          &nbsp;
          </>
        )}
        <span dangerouslySetInnerHTML={{ __html: itemText }}/>
        {iconName.length > 0 && iconPosition !== 'before' && (
          <>
          &nbsp;
          <LdsIcon name={iconName} inline decorative />
          </>
        )}
      </a>

      {/* {iconName.length > 0 && iconPosition === 'before' && (
        <>
        <a
          href={href}
          aria-label={ariaLabel || itemText}
          className="lds-link"
          tabIndex={-1}
          target={`${newTab ? '_blank' : null}`}
          onClick={externalCallback}
        >
          <LdsIcon name={iconName} inline decorative />
        </a>
        &nbsp;
        </>
      )}
      <a
        href={href}
        aria-label={ariaLabel || itemText}
        className="lds-link"
        tabIndex={tabIndex}
        target={`${newTab ? '_blank' : null}`}
        onClick={externalCallback}
        dangerouslySetInnerHTML={{
          __html: itemText,
        }}
      />
      {iconName.length > 0 && iconPosition !== 'before' && (
        <>
        &nbsp;
        <a
          href={href}
          aria-label={ariaLabel || itemText}
          className="lds-link"
          tabIndex={-1}
          target={`${newTab ? '_blank' : null}`}
          onClick={externalCallback}
        >
          <LdsIcon name={iconName} inline decorative />
        </a>
        </>
      )} */}
    </div>
  );
}
